import type { ReactElement } from 'react'
import styled from 'styled-components'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { Paragraph } from '@/components/enlayouts/Ir/Paragraph'
import { PDFItem } from '@/components/enlayouts/Ir/PDFItem'

export const BasicsPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Basic Policy"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <Paragraph>
        The company believes that Illogicalness, Unevenness, and Waste in the distribution and retail industry is crucial for 
        addressing social challenges and serving the needs of our customers. Our purpose is &quot;Enrich every aspect of people&apos;s 
        lives through all we do.&quot; Collaborating with stakeholders, including shareholders and investor, is integral to achieving 
        sustained corporate growth and enhancing corporate value. To attain these objectives, we emphasize the through of agile 
        decision-making through speedy management. Building and operating mechanisms to facilitate swift decision-making align with 
        the fundamental principles of corporate governance. We are committed to the continuous evolution and enhancement of corporate 
        governance based on these fundamental principles.
      </Paragraph>
      <Spacer h={{ sp: 30, pc: 30 }} />
      <PDFItem
        fileName="Corporate Governance Report (Available only in Japanese)"
        filePath="https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/b22d89e6-41c2-4fdb-959f-596c69a0d0a4/TRIAL_CorporateGovernanceReport_260929.pdf"
      />
      <Spacer h={{ sp: 20, pc: 30 }} />
      <PublishDate>September 29, 2026</PublishDate>
    </Layout>
  )
}

BasicsPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir/' },
    { name: 'Corporate Governance', path: '/en/ir/governance/' },
    { name: 'Basic Policy', path: '' },
  ]

  return (
    <>
      <Head
        title="Basic Policy "
        description="The fundamental principles of corporate governance."
        ogp={{ url: 'en/ir/governance/basics' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const PublishDate = styled.span`
  display: flex;
  justify-content: flex-end;
`
